import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { StoreType } from "../../../../core/store/reducers";
import { loadDividends } from "../thunks/loadDividends";
import { DividendList } from "../types";
import { PageData } from "../../../models";
import { invalidateDividends } from "../dividendsDataSlice";

export const useDividendsData = () => {
	const pageData = useSelector<StoreType, PageData<DividendList> | undefined>(
		s => s.data.reports.dividends.currentPage
	);

	const dispatch = useDispatch();
	
	const dispatchLoadDividendsPage = React.useCallback(() => dispatch(loadDividends()), [dispatch]);

	const dispatchInvalidate = React.useCallback(() => dispatch(invalidateDividends()), [dispatch]);

	return [pageData, dispatchLoadDividendsPage, dispatchInvalidate] as [
		typeof pageData,
		typeof dispatchLoadDividendsPage,
		typeof dispatchInvalidate
	];
};
